import keyMirror from 'react-utils/keyMirror';
export let FileExtensionFilterEnum;
(function (FileExtensionFilterEnum) {
  FileExtensionFilterEnum["SUPPORTED"] = "SUPPORTED";
  FileExtensionFilterEnum["UNSUPPORTED"] = "UNSUPPORTED";
  FileExtensionFilterEnum["NONE"] = "NONE";
})(FileExtensionFilterEnum || (FileExtensionFilterEnum = {}));
export default Object.freeze(keyMirror({
  SUPPORTED: null,
  UNSUPPORTED: null,
  NONE: null
}));